{
  "AUDIT_LOGS": {
    "HEADER": "Audit Logs",
    "HEADER_BTN_TXT": "Add Audit Logs",
    "LOADING": "Fetching Audit Logs",
    "DESCRIPTION": "Audit Logs maintain a record of activities in your account, allowing you to track and audit your account, team, or services.",
    "LEARN_MORE": "Learn more about audit logs",
    "SEARCH_404": "Няма резултати отговарящи на тази заявка",
    "SIDEBAR_TXT": "<p><b>Audit Logs</b> </p><p> Audit Logs are trails for events and actions in a Chatwoot System. </p>",
    "LIST": {
      "404": "There are no Audit Logs available in this account.",
      "TITLE": "Manage Audit Logs",
      "DESC": "Audit Logs are trails for events and actions in a Chatwoot System.",
      "TABLE_HEADER": {
        "ACTIVITY": "User",
        "TIME": "Action",
        "IP_ADDRESS": "IP адрес"
      }
    },
    "API": {
      "SUCCESS_MESSAGE": "AuditLogs retrieved successfully",
      "ERROR_MESSAGE": "Не можа да се свърже с Woot сървър. Моля, опитайте отново по-късно"
    },
    "DEFAULT_USER": "System",
    "AUTOMATION_RULE": {
      "ADD": "{agentName} created a new automation rule (#{id})",
      "EDIT": "{agentName} updated an automation rule (#{id})",
      "DELETE": "{agentName} deleted an automation rule (#{id})"
    },
    "ACCOUNT_USER": {
      "ADD": "{agentName} invited {invitee} to the account as an {role}",
      "EDIT": {
        "SELF": "{agentName} changed their {attributes} to {values}",
        "OTHER": "{agentName} changed {attributes} of {user} to {values}",
        "DELETED": "{agentName} changed {attributes} of a deleted user to {values}"
      }
    },
    "INBOX": {
      "ADD": "{agentName} created a new inbox (#{id})",
      "EDIT": "{agentName} updated an inbox (#{id})",
      "DELETE": "{agentName} deleted an inbox (#{id})"
    },
    "WEBHOOK": {
      "ADD": "{agentName} created a new webhook (#{id})",
      "EDIT": "{agentName} updated a webhook (#{id})",
      "DELETE": "{agentName} deleted a webhook (#{id})"
    },
    "USER_ACTION": {
      "SIGN_IN": "{agentName} signed in",
      "SIGN_OUT": "{agentName} signed out"
    },
    "TEAM": {
      "ADD": "{agentName} created a new team (#{id})",
      "EDIT": "{agentName} updated a team (#{id})",
      "DELETE": "{agentName} deleted a team (#{id})"
    },
    "MACRO": {
      "ADD": "{agentName} created a new macro (#{id})",
      "EDIT": "{agentName} updated a macro (#{id})",
      "DELETE": "{agentName} deleted a macro (#{id})"
    },
    "INBOX_MEMBER": {
      "ADD": "{agentName} added {user} to the inbox(#{inbox_id})",
      "REMOVE": "{agentName} removed {user} from the inbox(#{inbox_id})"
    },
    "TEAM_MEMBER": {
      "ADD": "{agentName} added {user} to the team(#{team_id})",
      "REMOVE": "{agentName} removed {user} from the team(#{team_id})"
    },
    "ACCOUNT": {
      "EDIT": "{agentName} updated the account configuration (#{id})"
    },
    "CONVERSATION": {
      "DELETE": "{agentName} deleted conversation #{id}"
    }
  }
}
